<template>
   <v-container fluid>


  <div id="login_div">
    <v-row align="center" justify="center" >
      <v-col cols="11" md="8">
        <p class="text-center">
          <img src="@/assets/logo_infilesign_white.png" alt="Prisma Sign">
        </p>
      </v-col>
      <v-col cols="11" md="8" style="max-width:1000px" >
        <v-card v-if="etapa==1" class="elevation-12">
          <v-card-title class="title1">Crear cuenta</v-card-title>
          <v-card-text>
            <b>AVISO IMPORTANTE: USTED ESTÁ GESTIONANDO LA OBTENCIÓN DE UNA FIRMA ELECTRÓNICA
            “NO-AVANZADA” O FIRMA ELECTRÓNICA SIMPLE.</b> De conformidad con la legislación
            guatemalteca, <u>una firma electrónica avanzada</u> tiene el mismo valor jurídico que
            la firma manuscrita en relación con una firma consignada en formato papel y es 
            admisible como prueba en juicio y con ello, presume que el suscriptor tenía la
            intención de acreditar esa comunicación o contratación electrónica y ser 
            vinculado con el contenido de la misma. <b>Al emitirse una firma electrónica no
            avanzada o firma electrónica simple, al carecer de las calidades anteriores,
            Registro Digital Prisma, S.A. no se responsabilizará del uso que se le dé, 
            ni de la acreditación de identidad en las comunicaciones donde se utilice.</b>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-col cols="10" md="6" align="center" >
                <v-btn text color="secondary" class="mr-4" :to="{name: 'login'}">
                    Regresar a inicio de sesión
                </v-btn>
              </v-col>
              <v-col cols="10" md="6" align="center" >
                <v-btn color="primary" class="mr-4" @click="etapa=2">
                    Continuar con el registro
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-card v-if="etapa==2" class="elevation-12">
          <v-card-title class="title1">Crear cuenta</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="name" 
                      id="inputName"
                      class="mt-0 pt-0"
                      prepend-icon="person"
                      :rules="[rules.required]"
                      label="Nombre">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="lastname" 
                      prepend-icon="person"
                      class="mt-0 pt-0"
                      :rules="[rules.required]"
                      id="inputLastname"
                      label="Apellido">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="email" 
                      type="email"
                      id="inputEmail"
                      class="mt-0 pt-0"
                      :rules="[rules.required]" 
                      prepend-icon="email" 
                      label="Correo">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-select
                          :items="paises"
                          :item-text="paises.text"
                          :item-value="paises.value"
                          label="Pais"
                          :rules="[rules.required]"
                          prepend-icon="mdi-map"
                          class="mt-0 pt-0"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field 
                          v-model="telefono" 
                          id="telefono"
                          type="number"
                          label="Teléfono" 
                          class="mt-0 pt-0"
                          :rules="[rules.required, rules.telefono]"
                          >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      counter
                      v-model="password"
                      id="inputPass"
                      class="mt-0 pt-0"
                      prepend-icon="lock"
                      label="Contraseña"
                      :rules="[rules.required, rules.min, rules.size]" 
                      :type="show1 ? 'text' : 'password'"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show1 = !show1"
                      ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      counter
                      v-model="password_confirm"                   
                      id="inputPass2"
                      prepend-icon="lock" 
                      class="mt-0 pt-0"
                      label="Confirmación"
                      :type="show2 ? 'text' : 'password'"
                      :rules="[rules.required, passwordConfirmationRule, rules.size]" 
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                      required>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                      <v-alert
                        border="top"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <p><small>La contraseña debe contener:</small></p>
                        <ul>
                          <li><small>Al menos 1 carácter alfabético en minúscula.</small></li>
                          <li><small>Al menos 1 carácter alfabético en mayúscula.</small></li>
                          <li><small>Al menos 1 carácter numérico.</small></li>
                          <li><small>NO caracteres especiales (! @ $ %  & *).</small></li>
                          <li><small>La contraseña debe tener ocho caracteres o más.</small></li>
                        </ul>
                      </v-alert>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div id="recaptcha_panel">
                      <VueRecaptcha
                        @verify="onVerify"
                        class="recaptcha_panel"
                        @expired="onExpired"
                        ref="invisibleRecaptcha"
                        :loadRecaptchaScript="true"
                        sitekey="6Ld57yAaAAAAAPrNsozCiaj5g09ATutDEZcvBptn">
                        <!--      sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI">-->
                      </VueRecaptcha>
                    </div>
                  </v-col>
                </v-row>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
              <v-row justify="center">
                  <v-col cols="10" md="6" align="center">
                      <v-btn text color="secondary" class="mr-4" :to="{name: 'login'}">
                          Regresar a inicio de sesión
                      </v-btn>
                  </v-col>
                  <v-col cols="10" md="6" align="center">
                      <v-btn id="register" color="primary" class="mr-4"
                             :loading="loading" :disabled="!valid || !valid_captcha" @click="validate">
                          Continuar con el registro
                      </v-btn>
                   </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-if="etapa==3" class="elevation-12">
          <v-card-title class="title1">Usuario registrado exitosamente</v-card-title>
          <v-card-text>
            Se envió un correo de confirmación a su cuenta, 
            por favor seguir las instrucciones que se incluyen 
            allí para finalizar el proceso.
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
                <v-col cols="10" md="6" align="center">
                </v-col>
                <v-col cols="10" md="6" align="center">
                    <v-btn color="primary" class="mr-4" :to="{name: 'login'}">
                        Finalizar
                    </v-btn>
                </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>

</v-container> 

</template>
<script>
  import VueRecaptcha from 'vue-recaptcha';
  export default {
    components: { VueRecaptcha },
  	data: function() {
  	  return {
        etapa: 1,
        show_modal: false,
	      valid: true,
        justify: 'center',
        alignment: 'center',
	      name: '',
	      lastname: '',
	      password: "",
        password_confirm: "",
        codigo_pais: null,
	      email: '',
        telefono: '',
        valid_captcha: false,
		    show1: false,
        show2: false,
        paises: [
          { 'value': '+502', 'text': "Guatemala" },
        ],
        loading: false,
	      emailRules: [
	        v => !!v || 'Campo requerido',
	        v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
	      ],
        rules: {
          required: value => !!value || 'Campo requerido',
          min: v => v.length >= 8 || 'Min 8 caracteres',
          size:  v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(^[A-Za-z0-9]*$)/.test(v) || 'No es una contraseña permitida',
          telefono: v => /^([0-9]{8})$/.test(v) || '8 caracteres permitidos',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },
  	  };
  	},
    computed: {
      passwordConfirmationRule() {
        return () => (this.password === this.password_confirm) || 'Contraseñas no coinciden'
      },
    },
    mounted() {
      $("#inputName, #inputLastname, #inputPass, #inputEmail").keyup(function(event) {
        if (event.keyCode === 13) {
          $("#register").click();
        }
      });
    },
    methods: {
     validate () {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$store.dispatch('REGISTER', {
            email: this.email,
            password: this.password,
            nombre: this.name,
            telefono: this.telefono,
            apellido: this.lastname
          }).then((callback) => {
            this.loading = false;
            if(callback){  this.etapa=3;  }
          }).catch(error => {
            this.loading = false;
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
            console.log("error register");
            console.log(error.response.data);
          });
        }
      },
      finalizar () {
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: "si paso" });
        this.$refs.form.reset();
        this.$router.push({ 'name': 'login'});
      },
      onSubmit: function () {
        this.$refs.invisibleRecaptcha.execute();
      },
      onVerify: function (response) {
        //console.log('Verify: ' + response);
        this.valid_captcha = true;
      },
      onExpired: function () {
        this.valid_captcha = false;
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
    },
  };
</script>